export const ogTypeOptions = [
  "website",
  "article",
  "book",
  "profile",
  "business.business",
  "books.author",
  "books.book",
  "books.genre",
  "fitness.course",
  "game.achievement",
  "music.musician",
  "music.song",
  "music.album",
  "music.playlist",
  "music.radio_station",
  "place",
  "product",
  "product.group",
  "product.item",
  "restaurant.menu",
  "restaurant.menu_item",
  "restaurant.menu_section",
  "restaurant.restaurant",
  "video.movie",
  "video.episode",
  "video.tv_show",
  "video.other",
  "object",
];

export const ogLocaleOptions = [
  ["af_ZA", "Afrikaans (South Africa)"],
  ["ar_AR", "Arabic"],
  ["az_AZ", "Azerbaijani"],
  ["be_BY", "Belarusian"],
  ["bg_BG", "Bulgarian"],
  ["bn_IN", "Bengali (India)"],
  ["bs_BA", "Bosnian"],
  ["ca_ES", "Catalan"],
  ["cs_CZ", "Czech"],
  ["cy_GB", "Welsh"],
  ["da_DK", "Danish"],
  ["de_DE", "German"],
  ["el_GR", "Greek"],
  ["en_GB", "English (United Kingdom)"],
  ["en_IN", "English (India)"],
  ["en_US", "English (United States)"],
  ["es_ES", "Spanish (Spain)"],
  ["es_LA", "Spanish (Latin America)"],
  ["et_EE", "Estonian"],
  ["eu_ES", "Basque"],
  ["fa_IR", "Persian"],
  ["fi_FI", "Finnish"],
  ["fr_CA", "French (Canada)"],
  ["fr_FR", "French (France)"],
  ["ga_IE", "Irish"],
  ["gl_ES", "Galician"],
  ["gu_IN", "Gujarati"],
  ["he_IL", "Hebrew"],
  ["hi_IN", "Hindi (India)"],
  ["hr_HR", "Croatian"],
  ["hu_HU", "Hungarian"],
  ["hy_AM", "Armenian"],
  ["id_ID", "Indonesian"],
  ["is_IS", "Icelandic"],
  ["it_IT", "Italian"],
  ["ja_JP", "Japanese"],
  ["ka_GE", "Georgian"],
  ["kk_KZ", "Kazakh"],
  ["km_KH", "Khmer"],
  ["kn_IN", "Kannada"],
  ["ko_KR", "Korean"],
  ["la_VA", "Latin"],
  ["lt_LT", "Lithuanian"],
  ["lv_LV", "Latvian"],
  ["mk_MK", "Macedonian"],
  ["ml_IN", "Malayalam"],
  ["mr_IN", "Marathi"],
  ["ms_MY", "Malay"],
  ["nb_NO", "Norwegian (Bokmal)"],
  ["ne_NP", "Nepali"],
  ["nl_NL", "Dutch"],
  ["pa_IN", "Punjabi"],
  ["pl_PL", "Polish"],
  ["pt_BR", "Portuguese (Brazil)"],
  ["pt_PT", "Portuguese (Portugal)"],
  ["ro_RO", "Romanian"],
  ["ru_RU", "Russian"],
  ["sk_SK", "Slovak"],
  ["sl_SI", "Slovenian"],
  ["sq_AL", "Albanian"],
  ["sr_RS", "Serbian"],
  ["sv_SE", "Swedish"],
  ["sw_KE", "Swahili"],
  ["ta_IN", "Tamil"],
  ["te_IN", "Telugu"],
  ["th_TH", "Thai"],
  ["tl_PH", "Filipino"],
  ["tr_TR", "Turkish"],
  ["uk_UA", "Ukrainian"],
  ["ur_PK", "Urdu"],
  ["vi_VN", "Vietnamese"],
  ["zh_CN", "Chinese (Simplified)"],
  ["zh_HK", "Chinese (Hong Kong)"],
  ["zh_TW", "Chinese (Traditional)"],
];

const derivedFields = {
  url: ["og_url"],
  title: ["og_title", "twitter_title"],
  description: ["og_description", "twitter_description"],
  og_image: ["twitter_image"],
};

export const updateSeoField = (current, name, value) => {
  const next = { ...current, [name]: value };
  (derivedFields[name] || []).forEach((field) => {
    next[field] = value;
  });
  return next;
};

export const synchronizeSeoFields = (seoData) => ({
  ...seoData,
  og_url: seoData.url || "",
  og_title: seoData.title || "",
  twitter_title: seoData.title || "",
  og_description: seoData.description || "",
  twitter_description: seoData.description || "",
  twitter_image: seoData.og_image || "",
});

export const buildPageSeoPayload = (seoData) => {
  const pageSeoPayload = synchronizeSeoFields(seoData);
  [
    "review_schema",
    "organisation_schema",
    "organization_schema",
    "twitter_site",
    "twitter_card",
    "twitter_creator",
    "og_site_name",
  ].forEach((field) => delete pageSeoPayload[field]);
  return pageSeoPayload;
};
